import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import {getFilterSettings} from '@/util/costAnalyticsUtil'

const state = {
  filterSettings: getFilterSettings(),
  costAnalyticsData: {},
  detailCostAnalyticsData: {},
  originalDetailCostAnalyticsData: {},
  portionDetailCostAnalyticsData: {},
  portionDetailCostAnalyticsCompareData: {},
  filterOptions: {
    AZURE: {},
    GCP: {},
    AWS: {},
  },
  userFilters: [],
  visibleColumnFields: [],
  isCloseQuickFilterDropdown: false,
  isInitialLoad: false,
  isMonthly: false,
  isOthers: true
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/cost-analytics/index.js